import React, { Component } from 'react';

import * as constClass from '../constants/agent.js';
//import airports from '../constants/airports';
import FlightsList from './FlightsList';
import AirportSuggestionsInput from './AirportSuggestionsInput';
import SocialShareBar from './SocialShareBar'

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


class FlightsForm extends Component {
  constructor(props) {
    super(props);
    var oneWeekLater = new Date(+new Date() + 86400000 * 7); // Set default value to one week from now
    this.state = {
      from: 'Bali (DPS)',
      to: 'Bangkok (BKK)',
      date: oneWeekLater,
      flightData: null,
      loadingFlights: false,
      firstSearchDone: false,
      errors: {
        valid: {
          from: true,
          to: true,
          birthday: true
        }
      }
    };
    //console.log("constructor flightData:")
    //console.log(typeof this.state.flightData)
    //console.log(this.state.flightData)
    if (this.state.flightData !== null && this.state.flightData !== undefined) {
      console.log(this.state.flightData.length)
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeTo = this.onChangeTo.bind(this);
    this.onChangeFrom = this.onChangeFrom.bind(this);
  }

  onChangeTo = (event, { newValue }) => {
    this.setState({
      to: newValue
    });
  };

  onChangeFrom = (event, { newValue }) => {
    this.setState({
      from: newValue
    });
  };

  handleChange = name => event => {
    this.setState({[name]: event.target.value});
    console.log(this.state[name])
  }

  handleChangeDatePicker = date => {
    this.setState({date: date});
  }

  parse_date (dateObj) {
    const month = dateObj.getUTCMonth() + 1; //months from 1-12
    const day = dateObj.getDate();
    const year = dateObj.getUTCFullYear();

    const newdate = year + "-" + month + "-" + day;

    return newdate
  }

  async fetchFlights(url) {
    this.setState({ flightData: null})
    this.setState({ loadingFlights: true})
    //console.log("Fetching flights");
    //console.log("this.state.flightData")
    //console.log(this.state.flightData)
    //await this.setState({ flightData: flightdata.data})
    console.log("[*] Requesting flight data")
    const date = this.parse_date(this.state.date)
    const response = await fetch(url, {
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },

      //make sure to serialize your JSON body
      body: JSON.stringify({
        fly_to: this.state.to,
        fly_from: this.state.from,
        fly_date: date
      })
    })

    const json = await response.json()
    
    // Error handling
    // Nothing done here yet but the error handling
    // might come in handy in the future
    //console.log("[-] Returned 400")
    if (response.status == 200) {
      //console.log("[*] Returned 200")
    const data = json.data
    this.setState({ flightData: data})
    this.setState({ loadingFlights: false})
    this.setState({ firstSearchDone: true})
    } else if (response.status == 400) {
      const data = json.data;
      const error_msg = json.error;
      this.setState({ flightData: data})
      this.setState({ loadingFlights: false})
      this.setState({ firstSearchDone: true})
    }

  }

  async handleSubmit(event) {
    event.preventDefault();

    const backend_skypicker_url = constClass.BACKEND_URL + '/ticket/skypicker/'
    await this.fetchFlights(backend_skypicker_url);
  }

  render() {
    return (
      <div>
        <div className="row justify-content-center">
          <div className="col">
            <p className="h2">Generate your sample ticket</p>
            <SocialShareBar />
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-xs-12 col-lg-7">
            <a href="https://api.onwardflightticket.com/static/example_ticket.png" title="">
              <img src="https://api.onwardflightticket.com/static/example_ticket.png" className="img-fluid float-right w-25" alt="Dummy Ticket Example" />
            </a>
            <p className="text-justify">
              Generate your free sample ticket by searching for flights below.
              The dummy ticket contains real flight data, your name and birthdate.
            </p>
            <p className="text-justify">
              And the best part? Your PDF ticket is <strong>delivered via email</strong> instantly, so you can use it right away.
            </p>
            <p className="text-justify">
            <i class="bi bi-exclamation-triangle-fill text-warning"></i>
            <br/>
            Attention: the ticket you receive is NOT a real ticket but it looks like a real one. The responsibility for its usage lies solely with you.
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt-4">
          <div className="col-xs-12 col-lg-9">
            <div className="card bg-light">
              <div className="card-body">
                <form onSubmit={this.handleSubmit}>
                <div className="form-row justify-content-center">

                  <div className="col-xs-12 col-lg-4">
                    <AirportSuggestionsInput
                      onChange = {this.onChangeFrom}
                      value = {this.state.from}
                      description = "From"
                      iata_code_valid = {this.state.errors.valid.from}
                    />
                  </div>

                  <div className="col-xs-12 col-lg-4">
                    <AirportSuggestionsInput
                      onChange = {this.onChangeTo}
                      value = {this.state.to}
                      description = "To"
                      iata_code_valid = {this.state.errors.valid.to}
                    />
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="row">
                      <div className="col">
                        <strong>When</strong>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col">
                        <DatePicker
                          onChange = {date => {
                            this.setState({date: date});
                            console.log("type of date")
                            console.log(typeof this.state.date)
                          }}
                          selected = {this.state.date}
                          dateFormat="dd/MM/yyyy"
                          className="form-control form-control-lg"
                          todayButton={"Today"}
                          placeholderText="When"
                          minDate={new Date()}
                        />
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="form-row mt-4">
                    <div className="col">
                      <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={this.state.loadingFlights}>Find Flights!</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <br/>
        </div>
        <div className="row justify-content-center">
          <FlightsList flightData={this.state.flightData} loadingFlights={this.state.loadingFlights} firstSearchDone={this.state.firstSearchDone}/>
        </div>
      </div>

    );
  }
}

export default FlightsForm;
